import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect } from 'react';
import { useBoolean } from 'minimal-shared/hooks';
import { isEqualPath, isActiveLink, isExternalLink } from 'minimal-shared/utils';
import { usePathname } from 'src/routes/hooks';
import { NavItem } from './nav-desktop-item';
import { Nav, NavLi, NavUl, NavDropdown } from '../components';
import { NavItemDashboard } from './nav-desktop-item-dashboard';

// ----------------------------------------------------------------------

export function NavList({
  data,
  sx,
  ...other
}) {
  const pathname = usePathname();
  const navItemRef = useRef(null);
  const isActive = isActiveLink(pathname, data.path, !!data.children);
  const {
    value: open,
    onFalse: onClose,
    onTrue: onOpen
  } = useBoolean();
  useEffect(() => {
    if (open) onClose();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  const handleOpenMenu = () => data.children && onOpen();
  const renderNavItem = () => <NavItem ref={navItemRef}
  // slots
  path={data.path} title={data.title}
  // state
  open={open} active={isActive}
  // options
  hasChild={!!data.children} externalLink={isExternalLink(data.path)}
  // action
  onMouseEnter={handleOpenMenu} onMouseLeave={onClose} />;
  const renderDropdown = () => !!data.children && <NavDropdown open={open} onMouseEnter={handleOpenMenu} onMouseLeave={onClose}>
        <Nav>
          <NavUl sx={{
        gap: 3,
        flexDirection: 'row'
      }}>
            {data.children.map(list => <NavSubList key={list.subheader} subheader={list.subheader} data={list.items} />)}
          </NavUl>
        </Nav>
      </NavDropdown>;
  return <NavLi sx={[...(Array.isArray(sx) ? sx : [sx])]} {...other}>
      {renderNavItem()}
      {renderDropdown()}
    </NavLi>;
}
function NavSubList(t0) {
  const $ = _c(31);
  let data;
  let other;
  let subheader;
  let sx;
  if ($[0] !== t0) {
    ({
      data,
      subheader,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = data;
    $[2] = other;
    $[3] = subheader;
    $[4] = sx;
  } else {
    data = $[1];
    other = $[2];
    subheader = $[3];
    sx = $[4];
  }
  const pathname = usePathname();
  const isDashboard = subheader === "Dashboard";
  const t1 = isDashboard ? 1 : 0;
  let t2;
  if ($[5] !== isDashboard) {
    t2 = isDashboard && {
      maxWidth: 560
    };
    $[5] = isDashboard;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      flexGrow: 1,
      flexBasis: "auto",
      flexShrink: t1,
      ...t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== sx) {
    t4 = Array.isArray(sx) ? sx : [sx];
    $[10] = sx;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = [t3, ...t4];
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== subheader) {
    t6 = <NavLi sx={_temp}>{subheader}</NavLi>;
    $[15] = subheader;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== data || $[18] !== isDashboard || $[19] !== pathname) {
    let t8;
    if ($[21] !== isDashboard || $[22] !== pathname) {
      t8 = item => isDashboard ? <NavLi key={item.title} sx={{
        mt: 0.75
      }}><NavItemDashboard path={item.path} /></NavLi> : <NavLi key={item.title} sx={{
        mt: 0.75
      }}><NavItem subItem={true} title={item.title} path={item.path} active={isEqualPath(item.path, pathname)} /></NavLi>;
      $[21] = isDashboard;
      $[22] = pathname;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    t7 = data.map(t8);
    $[17] = data;
    $[18] = isDashboard;
    $[19] = pathname;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[24] !== t6 || $[25] !== t7) {
    t8 = <NavUl>{t6}{t7}</NavUl>;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== other || $[28] !== t5 || $[29] !== t8) {
    t9 = <NavLi sx={t5} {...other}>{t8}</NavLi>;
    $[27] = other;
    $[28] = t5;
    $[29] = t8;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
}
function _temp(theme) {
  return {
    mb: 0.75,
    typography: "overline",
    fontSize: theme.typography.pxToRem(11)
  };
}